import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const PREVIEW_WIDTH = "300px";
const PREVIEW_HEIGHT = "200px";
const SIDEBAR_WIDTH = "92px";
const LOGO_SIZE = "26px";

export const useStyles = makeStyles({
  outer: {
    display: "flex",
    width: PREVIEW_WIDTH,
    height: PREVIEW_HEIGHT,
    borderRadius: designTokens.borderRadius.md,
    border: `1px solid ${designTokens.neutral[200]}`,
    overflow: "hidden",
  },
  sidebar: {
    width: SIDEBAR_WIDTH,
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    padding: designTokens.spacing[2],
    gap: designTokens.spacing[2],
    backgroundColor: "var(--preview-sidebar-bg)",
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
  },
  logoImage: {
    width: LOGO_SIZE,
    height: LOGO_SIZE,
    borderRadius: designTokens.borderRadius.sm,
    objectFit: "contain" as const,
  },
  logoBadge: {
    width: LOGO_SIZE,
    height: LOGO_SIZE,
    borderRadius: designTokens.borderRadius.sm,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "9px",
    fontWeight: designTokens.fontWeight.bold,
    flexShrink: 0,
    backgroundColor: "var(--preview-accent-on-white)",
    color: "var(--preview-accent-on-white-text)",
  },
  appTitle: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    lineHeight: "1.25",
    minWidth: 0,
    overflowWrap: "anywhere" as const,
    color: "var(--preview-header-text)",
  },
  workspaceRow: {
    display: "block",
    fontSize: "10px",
    fontWeight: designTokens.fontWeight.medium,
    borderRadius: designTokens.borderRadius.sm,
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[2]}`,
    marginTop: "auto",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
    backgroundColor: "var(--preview-active-bg)",
    color: "var(--preview-active-text)",
  },
  main: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    padding: designTokens.spacing[2],
    backgroundColor: designTokens.neutral[100],
  },
  headerBar: {
    backgroundColor: designTokens.neutral.white,
    borderRadius: designTokens.borderRadius.sm,
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[2]}`,
    fontSize: "10px",
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.neutral[700],
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
    borderBottom: "2px solid var(--preview-accent-on-white)",
  },
  card: {
    backgroundColor: designTokens.neutral.white,
    borderRadius: designTokens.borderRadius.sm,
    padding: designTokens.spacing[2],
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
  cardTitle: {
    fontSize: "9px",
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[600],
  },
  badge: {
    alignSelf: "flex-start",
    fontSize: "8px",
    fontWeight: designTokens.fontWeight.bold,
    borderRadius: designTokens.borderRadius.sm,
    padding: `2px ${designTokens.spacing[1]}`,
    backgroundColor: "var(--preview-accent-on-white)",
    color: "var(--preview-accent-on-white-text)",
  },
});
